export function isSyncMessage(value) {
    if (typeof value !== "object" || value === null)
        return false;
    const m = value;
    if (m.v !== 1 || typeof m.type !== "string")
        return false;
    switch (m.type) {
        case "input":
        case "frame":
        case "state":
        case "hash":
        case "control":
            return true;
        default:
            return false;
    }
}
//# sourceMappingURL=sync.js.map